fragment CurrentUserTenantFragment on UserTenant {
  Id
  TenantId
  Tenant {
    Name
    ExternalCustomerId
  }
  UserTenantTypeCode
  UserTenantType {
    Name
  }
}
